const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      isAuthRequired: true
    },
    component: () => import('@/views/Dashboard.vue')
  }
  ]

  export default routes
